export { default } from './CustomBlock';
